import React from 'react';

import PageHeader from '../components/PageHeader';
import TabSection from '../components/TabSection';
import SectionHeading from '../components/SectionHeading';
import Button from '../components/Button';
import BackgroundAnimation from '../components/BackgroundAnimation';
import ImageSlider from '../components/ImageSlider';

import feature_phone_1 from '../../assets/images/feature-section-1-phone.png';
import feature_image_1 from '../../assets/images/feature-section-1-img.jpg';
import feature_phone_2 from '../../assets/images/feature-section-2-phone.png';
import feature_image_2 from '../../assets/images/feature-section-2-img.jpg';

import feature_tab from '../data/featureTab';
import faq from '../data/faq';

import background_image_1 from '../../assets/images/patterns/pattern-1.jpg';


const FeatureDetail1 = () => {
    return (
        <>
        {/* TODO change to align as figma */}
                   <div className="hero hero-1">
                <div className="hero-wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-8 offset-lg-0 order-lg-1 col-10 offset-1 order-2">
                                <div className="hero-content c-white">
                                        <h2 class="text-inter">Reescribiendo las reglas de</h2>
                                        <h2 class="text-inter">
                                            la selección: Más humano,</h2>
                                            <h2 class="text-inter">menos obsoleto.</h2>
                                    <p className="large">Descubre cómo Woowii combina tecnología, la empatía y la innovación <br></br>para revolucionar la forma en que empresas y candidatos se conectan.
                                    </p>
                                    <h3 className="large cursive-woowii" style={{fontWeight:"400"}}>Aquí no elegimos valores: los creamos.</h3>

                                </div>
                            </div>
                        </div>
                        
                    </div>
                    <div className="background-pattern background-pattern-1">
                        <BackgroundAnimation/>
                        <div className="background-pattern-gradient"></div>
                        <div className="background-pattern-bottom">
                            <div className="image" style={{backgroundImage: `url(${background_image_1})`}}></div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <p class="text-inter">
            Descubre cómo Woowii combina tecnología, la empatía y la innovación para revolucionar la forma en que empresas y candidatos se conectan.
            </p> */}
            {/* page header - end */}

      
            {/* tab section - start */}
            <TabSection data={feature_tab} subHeading='' />
            {/* tab section - end */}

            {/* feature section - start */}
            <div className="feature-section feature-section-0 feature-section-spacing-1">
        
            </div>
            {/* feature section - end */}

            {/* feature section - start */}
            <div style={{marginTop:"25rem"}} className="feature-section feature-section-1 feature-section-spacing-2">
            
            </div>
            {/* feature section - end */}

            {/* instagram - start */}
            {/* <div className="instagram">
                <div className="instagram-wrapper">
                    <ImageSlider/>
                    <div className="button-wrapper">
                        <Button
                            to='/'
                            content='Follow us on Instagram'
                            type='button-premium'
                            icon={<i className="fab fa-instagram"></i>}
                        />
                    </div>
                </div>
            </div> */}
            {/* instagram - end */}
            
        </>
    );
};

export default FeatureDetail1;
